// Self-contained: this function is embedded in the dispatch print window.
export function paginateDispatchInvoice(doc = document) {
  const original=doc.querySelector('[data-dispatch-table]');
  if(!original||doc.querySelector('.dispatch-print-page'))return;
  const header=doc.querySelector('[data-dispatch-header]');
  const ending=doc.querySelector('[data-dispatch-ending]');
  const rows=Array.from(original.tBodies[0].rows);
  const probe=doc.createElement('div');
  probe.style.cssText='position:absolute;visibility:hidden;height:194mm;width:1px';
  doc.body.appendChild(probe);
  const pageHeight=probe.getBoundingClientRect().height-2;
  probe.remove();
  if(pageHeight<=0)return;
  const pages=[];
  const makePage=()=>{
    const page=doc.createElement('section');page.className='dispatch-print-page';
    doc.body.insertBefore(page,header);
    page.appendChild(header.cloneNode(true));
    const table=original.cloneNode(false);
    table.appendChild(original.querySelector('colgroup').cloneNode(true));
    table.appendChild(original.tHead.cloneNode(true));
    const body=doc.createElement('tbody');table.appendChild(body);
    const totals=doc.createElement('tbody');
    totals.innerHTML='<tr class="page-subtotal"><th colspan="8" class="text-right">Page subtotal</th><th class="text-right">0.00</th></tr>';
    table.appendChild(totals);page.appendChild(table);
    // Reserve room for the grand total and signatures when measuring every page.
    const tail=ending.cloneNode(true);page.appendChild(tail);
    const number=doc.createElement('div');number.className='page-number';number.textContent='Page 1 of 1';page.appendChild(number);
    const result={page,body,totals,tail,number};pages.push(result);return result;
  };
  let current=makePage();
  for(const row of rows){
    current.body.appendChild(row);
    if(current.page.getBoundingClientRect().height>pageHeight&&current.body.rows.length>1){
      current.body.removeChild(row);current=makePage();current.body.appendChild(row);
    }
  }
  pages.forEach((part,index)=>{
    const subtotal=Array.from(part.body.rows).reduce((sum,row)=>sum+Number(row.dataset.lineTotal||0),0);
    part.totals.rows[0].cells[1].textContent=subtotal.toFixed(2);
    if(index!==pages.length-1)part.tail.remove();
    part.number.textContent=`Page ${index+1} of ${pages.length}`;
  });
  header.remove();original.remove();ending.remove();
}
